/* !ВНИМАНИЕ! */
// этот файл генерится скриптом
// npm run updatePartnerCodeVersion
// руками менять его не надо
export const pcodeVer = 7653;
